import { sortedCategory } from "@/utils/index";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	empty_legs_alert: {},
	email_notifications: {},
	aircraft_categories: [],
};

export const settingSlice = createSlice({
	name: "settings",
	initialState,
	reducers: {
		setSettingEmptyLegAlert: (state = {}, action = {}) => {
			state.empty_legs_alert = action.payload;
		},
		setSettingEmailNotifications: (state = {}, action = {}) => {
			state.email_notifications = action.payload;
		},
		setAircraftCategories: (state = {}, action = {}) => {
			state.aircraft_categories = sortedCategory(action.payload);
		},
	},
});

// Selectors
export const getSettings = (state) => state?.settings || {};

// Reducers and actions
export const { setSettingEmptyLegAlert, setSettingEmailNotifications, setAircraftCategories } = settingSlice.actions;

export default settingSlice.reducer;
